export default __webpack_public_path__ + "static/media/thumbnail3.642756a1.jpg";